<template>
  <z-pull-refresh v-model="refreshing" @refresh="onRefresh" ref="pullrefresh">
    <div class="box">
      <z-list key="now" v-model="loading" :finished="finished" finished-text="" :error.sync="error" :show-finished-img="false">
        <spam-card
          v-for="item in list"
          :key="item.id"
          :data="item"
          @onRefresh="onRefresh"
          :active="active"
        />
      </z-list>
      <div class="pass" v-if="!loading && list.length === 0 && +status === 0">
        <!-- <z-image lazy-load fit="cover" class="cover-image" :src="data.image" /> -->
        <z-icon name="passed" size="1.06rem" color="#ff483c" />
        <span class="passtext">{{ NormalObj[active] || '账号状态正常' }}</span>
      </div>
      <div class="expend" v-if="!loading && fetch">
        <div v-if="!expend" class="expend-text" @click="expendHistory">{{ '展开历史记录' }}</div>
        <z-icon v-if="!expend" name="arrow-down" size="0.32rem" color="#4A90E2" />
        <div v-if="expend && listHistory.length > 0" class="expend-text">
          {{ '以下为历史记录' }}
        </div>
      </div>
      <z-list
        key="history"
        v-if="expend"
        v-model="loadingHistory"
        :finished="finishedHistory"
        :error.sync="errorHistory"
        @load="onLoadHistory"
        :show-finished-img="false"
        :finished-text="historyFinishedText"
      >
        <spam-card
          v-for="item in listHistory"
          :key="item.id"
          :data="item"
          @onRefresh="onRefresh"
          :active="active"
        />
      </z-list>
    </div>
  </z-pull-refresh>
</template>

<script>
import native from '@zz-common/native-adapter'
import { List, Icon, PullRefresh } from '@zz-common/zz-ui'
// import DAL from '../../../../dal'
import { lego } from '@zz-common/lego'
import SpamCard from '../spam-card/index'
import { getSecurityCheck, getSecurityHistopry } from '../../../../api/resourceApi'

const NormalObj = {
  0: '账号状态正常',
  1: '功能状态正常',
  2: '商品状态正常',
  3: '钱款状态正常'
}
export default {
  name: 'AccountStatus',
  props: {
    active: Number
  },
  data() {
    return {
      list: [],
      error: false,
      loading: false,
      finished: true,
      refreshing: false,
      listHistory: [],
      errorHistory: false,
      loadingHistory: false,
      finishedHistory: false,
      refreshingHistory: false,
      expend: false,
      fetch: false,
      pageNum: 1,
      NormalObj,
      status: 1, // 0正常 1 不正常
      historyFinishedText: '到底了'
    }
  },
  components: {
    zPullRefresh: PullRefresh,
    zList: List,
    zIcon: Icon,
    // zImage: Image,
    SpamCard
  },
  methods: {
    onLoadHistory(isRefresh) {
      console.log('onLoad', isRefresh)
      if (isRefresh) {
        this.listHistory = []
      }
      this.loadingHistory = true
      this.getCheckHistyory()
      this.loadingHistory = false // 加载状态结束
    },
    async getCheckHistyory() {
      const params = {
        type: this.active,
        pageNum: this.pageNum++
      }
      const res = await getSecurityHistopry(params)
      const { list = [] } = res
      console.log(res)
      if (list.length <= 0) {
        console.log(this.$refs.pullrefresh.$el.scrollHeight, this.$refs.pullrefresh.$el.clientHeight)
        if (this.$refs.pullrefresh.$el.scrollHeight <= this.$refs.pullrefresh.$el.clientHeight) {
          this.historyFinishedText = ''
        }
        this.finishedHistory = true
        return
      }
      this.listHistory.push(...list)
    },
    onLoad(isRefresh) {
      console.log('onLoad', isRefresh)
      if (isRefresh) {
        this.list = []
      }
      this.loading = true
      this.getCheck()
      this.loading = false // 加载状态结束
    },
    async getCheck() {
      const res = await getSecurityCheck({ type: this.active })
      const { list = [], tabNumObj = {}, status } = res
      this.loading = false
      this.$emit('setTabNum', tabNumObj)
      console.log(res)
      this.fetch = true
      this.list = list
      this.status = status
    },
    onRefresh() {
      this.status = 1
      this.onLoad(true)
      if (this.expend) {
        this.finishedHistory = false
        this.pageNum = 1
        this.onLoadHistory(true)
      }
      setTimeout(() => {
        this.refreshing = false
      }, 500)
    },
    handleVisiable(e) {
      if (e.target.visibilityState === 'visible') {
        console.log('我回来了')
        this.onRefresh()
        // 要执行的方法
      }
    },
    expendHistory() {
      this.onLoadHistory()
      this.expend = !this.expend
      lego.send({
        pagetype: 'ZZUP_SAFECENTER_DETIAL',
        actiontype: 'HISTORY_CLICK',
        backup: {
          active: this.active
        }
      })
    }
  },
  mounted() {
    this.onLoad()
    document.addEventListener('visibilitychange', this.handleVisiable)
  },
  destroyed() {
    document.removeEventListener('visibilitychange', this.handleVisiable)
  },
  beforeRouteEnter(to, from, next) {
    console.log('account-status to', to)
    console.log('account-status from', from)
    next((_vm) => {
      native.wrap('resetRightAllButton')()
    })
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
